import { WarningIcon } from '@chakra-ui/icons'
import { Box, Icon, Tooltip } from '@chakra-ui/react'

export function WarningEnderecoEditado() {
  return (
    <Box position="absolute" top="-1" left="-23px">
      <Tooltip label="Esse endereço foi editado pelo vendedor!" bg="gray.300" color="black">
        <Icon as={WarningIcon} color="#378BBF" fontSize="20px" />
      </Tooltip>
    </Box>
  )
}
